import $ from 'jquery';
import {Swiper, Navigation, Autoplay} from 'swiper/swiper.esm.js';
Swiper.use([Navigation, Autoplay]);

$('.image-swiper').each(function () {
    const $self = $(this);
    const $section = $self.closest('section');

    const swiper = new Swiper($self[0], {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        breakpoints: {
            450: {
                slidesPerView: 2
            },
            750: {
                slidesPerView: 3
            },
            1000: {
                slidesPerView: 4
            },
        },
        navigation:{
            nextEl: ".image-swiper-button-next",
            prevEl: ".image-swiper-button-prev",
        },
    });
});
